import { MetadataStore } from 'breeze-client';

import { Agenda } from './agenda';
import { AuctionItem } from './auction-item';
import { AuctionPaddle } from './auction-paddle';
import { AuctionPaddleUser } from './auction-paddle-user';
import { AuctionPurchase } from './auction-purchase';
import { Audit } from './audit';
import { AuditLog } from './audit-log';
import { AuthRefreshToken } from './auth-refresh-token';
import { BackgroundCheck } from './background-check';
import { BankTransaction } from './bank-transaction';
import { BankTransactionType } from './bank-transaction-type';
import { CalendarEvent } from './calendar-event';
import { CalendarEventLocation } from './calendar-event-location';
import { CalendarEventType } from './calendar-event-type';
import { Campaign } from './campaign';
import { CampaignAction } from './campaign-action';
import { CampaignOptOut } from './campaign-opt-out';
import { ChristianEducationSupport } from './christian-education-support';
import { CloverAccount } from './clover-account';
import { Committee } from './committee';
import { CommitteeAttachment } from './committee-attachment';
import { CommitteeAttachmentEmail } from './committee-attachment-email';
import { CommitteeAttachmentEmailLink } from './committee-attachment-email-link';
import { CommitteeAttachmentReview } from './committee-attachment-review';
import { CommitteeMember } from './committee-member';
import { Contribution } from './contribution';
import { ContributionAccount } from './contribution-account';
import { ContributionAccountAttachment } from './contribution-account-attachment';
import { ContributionBatch } from './contribution-batch';
import { ContributionBatchNote } from './contribution-batch-note';
import { ContributionBatchStatus } from './contribution-batch-status';
import { ContributionCash } from './contribution-cash';
import { ContributionLine } from './contribution-line';
import { ContributionPayment } from './contribution-payment';
import { ContributionType } from './contribution-type';
import { Family } from './family';
import { FamilyStatus } from './family-status';
import { GivingAttachment } from './giving-attachment';
import { Group } from './group';
import { GroupFamily } from './group-family';
import { GroupPerson } from './group-person';
import { HistoricalGiving } from './historical-giving';
import { Household } from './household';
import { Interest } from './interest';
import { InterestCategory } from './interest-category';
import { InterestSurvey } from './interest-survey';
import { InterestSurveyInterest } from './interest-survey-interest';
import { Invoice } from './invoice';
import { InvoiceLine } from './invoice-line';
import { Involvement } from './involvement';
import { InvolvementSkill } from './involvement-skill';
import { Log } from './log';
import { LookupValue } from './lookup-value';
import { Message } from './message';
import { MessageAttachment } from './message-attachment';
import { MessageSent } from './message-sent';
import { Nomination } from './nomination';
import { NominationAssignment } from './nomination-assignment';
import { NominationException } from './nomination-exception';
import { NominationTally } from './nomination-tally';
import { NominationVote } from './nomination-vote';
import { OfferingSchedule } from './offering-schedule';
import { OnlineContribution } from './online-contribution';
import { Person } from './person';
import { PersonInterest } from './person-interest';
import { PersonStatus } from './person-status';
import { Photo } from './photo';
import { PhotoLink } from './photo-link';
import { Pledge } from './pledge';
import { PledgeLine } from './pledge-line';
import { Proposal } from './proposal';
import { ProposalDiscussion } from './proposal-discussion';
import { ProposalVote } from './proposal-vote';
import { Relationship } from './relationship';
import { Role } from './role';
import { School } from './school';
import { Setting } from './setting';
import { TextGroupLink } from './text-group-link';
import { TextMessage } from './text-message';
import { TextMessageSent } from './text-message-sent';
import { User } from './user';
import { UserRole } from './user-role';
import { Visit } from './visit';
import { VisitType } from './visit-type';

export class ArkRegistrationHelper {

    static register(metadataStore: MetadataStore) {
        metadataStore.registerEntityTypeCtor('Agenda', Agenda);
        metadataStore.registerEntityTypeCtor('AuctionItem', AuctionItem);
        metadataStore.registerEntityTypeCtor('AuctionPaddle', AuctionPaddle);
        metadataStore.registerEntityTypeCtor('AuctionPaddleUser', AuctionPaddleUser);
        metadataStore.registerEntityTypeCtor('AuctionPurchase', AuctionPurchase);
        metadataStore.registerEntityTypeCtor('Audit', Audit);
        metadataStore.registerEntityTypeCtor('AuditLog', AuditLog);
        metadataStore.registerEntityTypeCtor('AuthRefreshToken', AuthRefreshToken);
        metadataStore.registerEntityTypeCtor('BackgroundCheck', BackgroundCheck);
        metadataStore.registerEntityTypeCtor('BankTransaction', BankTransaction);
        metadataStore.registerEntityTypeCtor('BankTransactionType', BankTransactionType);
        metadataStore.registerEntityTypeCtor('CalendarEvent', CalendarEvent);
        metadataStore.registerEntityTypeCtor('CalendarEventLocation', CalendarEventLocation);
        metadataStore.registerEntityTypeCtor('CalendarEventType', CalendarEventType);
        metadataStore.registerEntityTypeCtor('Campaign', Campaign);
        metadataStore.registerEntityTypeCtor('CampaignAction', CampaignAction);
        metadataStore.registerEntityTypeCtor('CampaignOptOut', CampaignOptOut);
        metadataStore.registerEntityTypeCtor('ChristianEducationSupport', ChristianEducationSupport);
        metadataStore.registerEntityTypeCtor('CloverAccount', CloverAccount);
        metadataStore.registerEntityTypeCtor('Committee', Committee);
        metadataStore.registerEntityTypeCtor('CommitteeAttachment', CommitteeAttachment);
        metadataStore.registerEntityTypeCtor('CommitteeAttachmentEmail', CommitteeAttachmentEmail);
        metadataStore.registerEntityTypeCtor('CommitteeAttachmentEmailLink', CommitteeAttachmentEmailLink);
        metadataStore.registerEntityTypeCtor('CommitteeAttachmentReview', CommitteeAttachmentReview);
        metadataStore.registerEntityTypeCtor('CommitteeMember', CommitteeMember);
        metadataStore.registerEntityTypeCtor('Contribution', Contribution);
        metadataStore.registerEntityTypeCtor('ContributionAccount', ContributionAccount);
        metadataStore.registerEntityTypeCtor('ContributionAccountAttachment', ContributionAccountAttachment);
        metadataStore.registerEntityTypeCtor('ContributionBatch', ContributionBatch);
        metadataStore.registerEntityTypeCtor('ContributionBatchNote', ContributionBatchNote);
        metadataStore.registerEntityTypeCtor('ContributionBatchStatus', ContributionBatchStatus);
        metadataStore.registerEntityTypeCtor('ContributionCash', ContributionCash);
        metadataStore.registerEntityTypeCtor('ContributionLine', ContributionLine);
        metadataStore.registerEntityTypeCtor('ContributionPayment', ContributionPayment);
        metadataStore.registerEntityTypeCtor('ContributionType', ContributionType);
        metadataStore.registerEntityTypeCtor('Family', Family);
        metadataStore.registerEntityTypeCtor('FamilyStatus', FamilyStatus);
        metadataStore.registerEntityTypeCtor('GivingAttachment', GivingAttachment);
        metadataStore.registerEntityTypeCtor('Group', Group);
        metadataStore.registerEntityTypeCtor('GroupFamily', GroupFamily);
        metadataStore.registerEntityTypeCtor('GroupPerson', GroupPerson);
        metadataStore.registerEntityTypeCtor('HistoricalGiving', HistoricalGiving);
        metadataStore.registerEntityTypeCtor('Household', Household);
        metadataStore.registerEntityTypeCtor('Interest', Interest);
        metadataStore.registerEntityTypeCtor('InterestCategory', InterestCategory);
        metadataStore.registerEntityTypeCtor('InterestSurvey', InterestSurvey);
        metadataStore.registerEntityTypeCtor('InterestSurveyInterest', InterestSurveyInterest);
        metadataStore.registerEntityTypeCtor('Invoice', Invoice);
        metadataStore.registerEntityTypeCtor('InvoiceLine', InvoiceLine);
        metadataStore.registerEntityTypeCtor('Involvement', Involvement);
        metadataStore.registerEntityTypeCtor('InvolvementSkill', InvolvementSkill);
        metadataStore.registerEntityTypeCtor('Log', Log);
        metadataStore.registerEntityTypeCtor('LookupValue', LookupValue);
        metadataStore.registerEntityTypeCtor('Message', Message);
        metadataStore.registerEntityTypeCtor('MessageAttachment', MessageAttachment);
        metadataStore.registerEntityTypeCtor('MessageSent', MessageSent);
        metadataStore.registerEntityTypeCtor('Nomination', Nomination);
        metadataStore.registerEntityTypeCtor('NominationAssignment', NominationAssignment);
        metadataStore.registerEntityTypeCtor('NominationException', NominationException);
        metadataStore.registerEntityTypeCtor('NominationTally', NominationTally);
        metadataStore.registerEntityTypeCtor('NominationVote', NominationVote);
        metadataStore.registerEntityTypeCtor('OfferingSchedule', OfferingSchedule);
        metadataStore.registerEntityTypeCtor('OnlineContribution', OnlineContribution);
        metadataStore.registerEntityTypeCtor('Person', Person);
        metadataStore.registerEntityTypeCtor('PersonInterest', PersonInterest);
        metadataStore.registerEntityTypeCtor('PersonStatus', PersonStatus);
        metadataStore.registerEntityTypeCtor('Photo', Photo);
        metadataStore.registerEntityTypeCtor('PhotoLink', PhotoLink);
        metadataStore.registerEntityTypeCtor('Pledge', Pledge);
        metadataStore.registerEntityTypeCtor('PledgeLine', PledgeLine);
        metadataStore.registerEntityTypeCtor('Proposal', Proposal);
        metadataStore.registerEntityTypeCtor('ProposalDiscussion', ProposalDiscussion);
        metadataStore.registerEntityTypeCtor('ProposalVote', ProposalVote);
        metadataStore.registerEntityTypeCtor('Relationship', Relationship);
        metadataStore.registerEntityTypeCtor('Role', Role);
        metadataStore.registerEntityTypeCtor('School', School);
        metadataStore.registerEntityTypeCtor('Setting', Setting);
        metadataStore.registerEntityTypeCtor('TextGroupLink', TextGroupLink);
        metadataStore.registerEntityTypeCtor('TextMessage', TextMessage);
        metadataStore.registerEntityTypeCtor('TextMessageSent', TextMessageSent);
        metadataStore.registerEntityTypeCtor('User', User);
        metadataStore.registerEntityTypeCtor('UserRole', UserRole);
        metadataStore.registerEntityTypeCtor('Visit', Visit);
        metadataStore.registerEntityTypeCtor('VisitType', VisitType);
    }
}
